import { render, staticRenderFns } from "./ProductItemUpdate.vue?vue&type=template&id=2e927303&"
import script from "./ProductItemUpdate.vue?vue&type=script&lang=js&"
export * from "./ProductItemUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports